<div
  [formGroup]="formGroup"
  class="flex flex-col w-full"
  *transloco="let t">
  <mat-slide-toggle
    [name]="controlName"
    [formControlName]="controlName"
    [id]="inputId"
    [labelPosition]="labelPosition"
    [disabled]="disabled">
    @if (label) {
      {{ t(label) | capitalize }}
    }
  </mat-slide-toggle>
  @if (validateField.hasErrorValidate(formControl, 'required')) {
    <mat-error>{{ t('required-field') }}</mat-error>
  }
</div>
